import { http } from '@/shared/api';
import type { NotificationsListResponse } from './types';

export const notificationsApi = {
  list: (): Promise<NotificationsListResponse> => http<NotificationsListResponse>('/notifications'),

  markRead: (id: string): Promise<void> =>
    http<void>(`/notifications/${id}/read`, { method: 'POST' }),

  dismiss: (id: string): Promise<void> =>
    http<void>(`/notifications/${id}`, { method: 'DELETE' }),
};
